import axios from "axios";

export default axios.create({
  baseURL: "https://lmsaero.aeonsoftware.net/cit",
});
